export default __webpack_public_path__ + "static/media/add-new.00ebd317.svg";